export const ROUTES = {
    ROOT: '/',
    SIGNUP: '/signup',
    VERIFICATION: '/verification',
    CHA_DOCUMENT: '/cha',
    SHORT_FEES_DOCUMENT: '/shortFees',
    LONG_FEES_DOCUMENT: '/longFees'
}